import { t } from 'i18next';

const getColumns = () => [
  { key: 'name', label: t('form.name'), isSortActive: true },
  { key: 'email', label: t('form.email') },
  { key: 'phone', label: t('form.phone') },
];

export default getColumns;
